import { createRouter, createWebHistory } from 'vue-router';
// import HomeView from '../views/HomeView.vue';
import store from '@/store/index.js'
import LoginView from '@/views/Login/LoginView.vue';
import DashboardView from '@/views/Dashboard/DashboardView.vue';
import ProspectsView from '@/views/Prospects/ProspectsView.vue';
import GarantiesView from '@/views/Prospects/GarantiesView.vue';
import SecteurActiviteView from '@/views/Prospects/SecteurActiviteView.vue';
import ProspectionView from '@/views/Prospects/ProspectionView.vue';
import UtilisateurView from '@/views/Parametres/UtilisateurView.vue';



const routes = [
    {
        path: '/',
        name: 'login',
        component: LoginView
    },
    
    {
        path: '/dashboard',
        name: 'dashboard', 
        component: DashboardView
    },
    
    {
        path: '/prospects',
        name: 'prospects', 
        component: ProspectsView
    },
    {
        path: '/garanties',
        name: 'garanties', 
        component: GarantiesView
    },
    {
        path: '/secteurs',
        name: 'secteurs', 
        component: SecteurActiviteView
    },
    {
        path: '/prospections',
        name: 'prospections', 
        component: ProspectionView
    },
    
   
    
    {
        path: '/utilisateurs',
        name: 'utilisateurs', 
        component: UtilisateurView
    }

    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    await store.restored
    if( to.name != 'login' && !store.getters.isAuthenticated ) 
    {
        next({ name: 'login' }) ;
    }
    else { 
        next() ;
    }
});

export default router
